import Button from '@components/Button/Button';

interface CtaButtonProps {
  label: string;
  url: string;
  mobile?: boolean;
}

export function CtaButton({ label, url, mobile }: CtaButtonProps) {
  if (!label || !url) {
    return null;
  }

  const handleClick = () => {
    window.InteractTracking?.track('book_demo_nav_click', {
      page_name: document.title,
    });
  };

  return (
    <Button
      url={url}
      variant="primary"
      size={mobile ? 'small' : 'medium'}
      title={label}
      onClick={handleClick}
    >
      {label}
    </Button>
  );
}
